import { ChartBarIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import RetentionOfferShell from '../RetentionOfferShell.component';
import { tExtensionOfferModalProps } from '../RetentionOfferModal.types';

/**
 * The extension offer for a customer leaving because the results did not come:
 * the results session — one 1:1 with a specialist — and extra days to put the
 * changes in place. The days come from the offer the server resolved — the
 * modal only frames it.
 */
export default function NotSeeingResultsOfferModal(
  props: tExtensionOfferModalProps,
) {
  const {
    isOpen,
    offer,
    onAcceptOffer,
    onFinalizeSubscription,
    onBack,
    onClose,
    isLoadingOfferAcceptance,
    isLoadingFinalization,
  } = props;
  const { t } = useTranslation('settings/SubscriptionManager');
  const days = { days: offer.durationDays };

  return (
    <RetentionOfferShell
      isOpen={isOpen}
      heading={t('cancelSubscription.retentionOfferResults.heading')}
      intro={t('cancelSubscription.retentionOfferResults.intro')}
      cardIcon={ChartBarIcon}
      cardTitle={t('cancelSubscription.retentionOfferResults.subheading')}
      cardTerm={t('cancelSubscription.retentionOfferResults.offerTerm')}
      // Testimonials return only with real, approved customer quotes (PD8, 2026-09-25).
      onBack={onBack}
      onDecline={onFinalizeSubscription}
      onAccept={onAcceptOffer}
      acceptLabel={t(
        'cancelSubscription.retentionOfferResults.acceptButton',
        days,
      )}
      declineLabel={t('cancelSubscription.retentionOfferResults.declineButton')}
      onClose={onClose}
      isLoadingAccept={isLoadingOfferAcceptance}
      isLoadingDecline={isLoadingFinalization}
      testIdPrefix="not-seeing-results-offer"
    >
      <ul className="flex flex-col gap-3">
        <li className="flex items-start gap-2 text-base text-neutral-700">
          <CheckCircleIcon
            aria-hidden="true"
            className="mt-0.5 h-5 w-5 flex-shrink-0 text-success"
          />
          <div className="flex flex-col gap-1">
            <span className="font-semibold text-neutral-800">
              {t('cancelSubscription.retentionOfferResults.detail1')}
            </span>
            <ul className="flex list-disc flex-col gap-1 pl-5 text-sm text-neutral-600">
              <li>{t('cancelSubscription.retentionOfferResults.detail1a')}</li>
              <li>{t('cancelSubscription.retentionOfferResults.detail1b')}</li>
            </ul>
          </div>
        </li>
        <li className="flex items-start gap-2 text-base text-neutral-700">
          <CheckCircleIcon
            aria-hidden="true"
            className="mt-0.5 h-5 w-5 flex-shrink-0 text-success"
          />
          <span className="font-semibold text-neutral-800">
            {t('cancelSubscription.retentionOfferResults.detail2', days)}
          </span>
        </li>
      </ul>
    </RetentionOfferShell>
  );
}
